import { addTranslation } from '@shared/lib'
import { en } from './en'
import { ru } from './ru'

export const I18N_NAMESPACE = 'step-progress'

addTranslation(I18N_NAMESPACE, {en, ru})